import type { TouchEvent } from 'react';

const ANT_MODAL_CLOSE_SELECTOR = '.ant-modal-close';
type OnClose = () => void;

const preventGhostClick = (event: TouchEvent<Element>): void => {
  event.preventDefault();
};

/**
 * For Ant Design Modal: wrap `modalRender` output in a div with this onTouchEnd.
 * Suppresses ghost clicks on title/body and calls onClose when the tap ended on the close control
 * (rc-dialog uses onClick on the button; on touch that synthetic click may miss the overlay).
 */
export const handleAntModalPanelTouchEnd = (
  event: TouchEvent<HTMLDivElement>,
  onClose: OnClose
): void => {
  preventGhostClick(event);

  if (!(event.target instanceof Element)) return;
  if (!event.target.closest(ANT_MODAL_CLOSE_SELECTOR)) return;

  onClose();
};

/**
 * For close controls on full-screen overlays: prevents the synthetic click
 * mobile browsers emit after touch, which can hit content underneath once the overlay unmounts.
 */
export const closeOnTouchEndWithoutGhostClick = (
  event: TouchEvent<Element>,
  onClose: OnClose
): void => {
  preventGhostClick(event);
  onClose();
};
